import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import ZeusLink from './shared/ZeusLink';

interface SectionProps {
  title: string;
  children: React.ReactNode;
  count?: number;
  summaryLink?: {
    label: string;
    path: string;
  };
}

export function Section({ title, children, count, summaryLink }: SectionProps) {
  return (
    <Box mx={-3}>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="h6" fontWeight={600}>
              {title}
            </Typography>
            {count != null && (
              <Typography color="text.secondary" fontWeight="bold">
                ({count})
              </Typography>
            )}
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ px: 3 }}>
          {children}
          {summaryLink && (
            <Box mt={3}>
              <ZeusLink path={summaryLink.path}>{summaryLink.label}</ZeusLink>
            </Box>
          )}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

interface SectionItemProps {
  label: string;
  children: React.ReactNode;
}

export function SectionItem({ label, children }: SectionItemProps) {
  return (
    <Box>
      <Typography variant="subtitle2" color="textSecondary" fontWeight={400}>
        {label}
      </Typography>
      <Typography>{children}</Typography>
    </Box>
  );
}
